import { useTranslation } from "react-i18next";

import { InfoTooltip } from "components/Table/components/InfoTooltip";

const Unknown = () => {
    const { t } = useTranslation();

    return (
        <span>
            {t("Table details##bluetooth password##unknown")}

            <InfoTooltip
                aria-label={t(
                    "Table details##bluetooth password##aria label unknown tooltip"
                )}
                title={t("Table details##bluetooth password##unknown tooltip")}
            />
        </span>
    );
};

export default Unknown;
